<template>
	<div style="width: 100%">
		<vue-dropzone
			v-on:vdropzone-thumbnail="thumbnail"
			v-on:vdropzone-file-added="add"
			ref="myVueDropzone"
			id="dropzone"
			:options="dropzoneOptions"></vue-dropzone>
		<b-table
			v-if="nb_files > 0"
			striped
			hover
			:items="files"
			:fields="fields">
			<template v-slot:cell(del)="data">
				<b-button v-on:click="del_file(data.value, data.value.name)"
					><i class="fas fa-trash-alt"></i
				></b-button>
			</template>
		</b-table>
	</div>
</template>

<script>
	import vue2Dropzone from "vue2-dropzone";
	import "vue2-dropzone/dist/vue2Dropzone.min.css";

	var clone = require("clone");

	import * as json2csv from "json2csv";

	import files_service from "../services/files.js";

	export default {
		name: "file_upload",
		components: {
			vueDropzone: vue2Dropzone,
		},
		props: {
			upload: {
				default: false
			}
		},
		data: function () {
			return {
				first: false,
				dropzoneOptions: {
					url: `${process.env.VUE_APP_SAAS_BACK}`,
					dictDefaultMessage: "Télécharger les fichiers",
					autoProcessQueue: false,
					uploadMultiple: true,
					maxFiles: 10000,
					parallelUploads: 10000,
					previewTemplate: this.template(),
					timeout: 3600000,
					maxFilesize: 10000,
				},
				counter: 0,
				files: [],
				files_data: [],
				nb_files: 0,
				size_files: 0,
				fields: [
					{
						key: "name",
						label: "Nom",
					},
					{
						key: "size",
						label: "Taille",
					},
					{
						key: "del",
						label: "",
					},
				],
			};
		},
		watch: {
			files_data: {
				deep: true,
				handler() {
					this.$emit("update", this.files_data);
				},
			},
		},
		methods: {
			get_data() {
				//console.log("get_data")
				if (this.upload)
				{
					var files = clone(this.files);

					for (var i = 0; i < files.length; i++)
					{
						delete files[i].del;
						delete files[i].size;
					}

					return files;
				}
				else
					return [];
			},
			set_data() {},
			get_data_files: async function (all_files = true) {
				//console.log("get_data_files " + this.upload)
				if (this.upload)
				{
					var data = this.get_data();

					var str_csv = json2csv.parse(data, {
						fields: Object.keys(data.length > 0 ? data[0] : {}),
						fieldNames: Object.keys(data.length > 0 ? data[0] : {}),
					});

					return [
						new File([str_csv], "data.csv", {
							type: "text/csv",
						}),
					];
				}
				else
					return this.files_data;
			},

			get_data_blob: async function () {
				// console.log("get_data_blob")
				var data = this.get_data();

				var str_csv = json2csv.parse(data, {
					fields: Object.keys(data.length > 0 ? data[0] : {}),
					fieldNames: Object.keys(data.length > 0 ? data[0] : {}),
				});

				return new Blob([str_csv], {
					type: "text/plain",
				});
			},
			load() {
				return {};
			},
			save() {},
			template: function () {
				return `<div></div>`;
			},
			thumbnail: function (file, dataUrl) {
				var j, len, ref, thumbnailElement;
				if (file.previewElement) {
					file.previewElement.classList.remove("dz-file-preview");
					ref = file.previewElement.querySelectorAll(
						"[data-dz-thumbnail-bg]"
					);
					for (j = 0, len = ref.length; j < len; j++) {
						thumbnailElement = ref[j];
						thumbnailElement.alt = file.name;
						thumbnailElement.style.backgroundImage =
							'url("' + dataUrl + '")';
					}
					return setTimeout(
						(function (_this) {
							return function () {
								return file.previewElement.classList.add(
									"dz-image-preview"
								);
							};
						})(this),
						1
					);
				}
			},
			async add(file) {
				console.log(file)
				var f = {
					name: file.name,
					size: (file.size / 1000000).toFixed(3) + " mo",
					del: file.upload.uuid,
				};

				if (this.upload)
				{
					var resp = await files_service.upload(file);

					f.url = (resp.urls && resp.urls.length > 0) ? resp.urls[0] : ""
				}

				this.files.push(f);
				this.files_data.push(file);
				this.nb_files++;
				this.size_files = (
					parseFloat(this.size_files) +
					parseFloat(file.size / 1000000)
				).toFixed(3);
			},
			del_file(uuid = null) {
				var dropzone_files = this.$refs.myVueDropzone.getQueuedFiles();
				var size = 0;

				if (uuid == null) {
					this.nb_files = 0;
					this.size_files = 0;
					this.files = [];
					this.files_data = [];
				}

				for (var i = 0; i < dropzone_files.length; i++) {
					if (dropzone_files[i]["upload"]["uuid"] == uuid) {
						size = dropzone_files[i]["size"];
						this.$refs.myVueDropzone.removeFile(dropzone_files[i]);
					}
				}
				for (var i = 0; i < this.files.length; i++) {
					if (this.files[i].del == uuid) {
						this.nb_files--;
						this.size_files = (
							parseFloat(this.size_files) -
							parseFloat(size / 1000000)
						).toFixed(3);
						this.files.splice(i, 1);
						this.files_data.splice(i, 1);
					}
				}
			},
		},
		mounted: async function () {},
	};
</script>

<style>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}

	#dropzone .dz-message {
		margin: 0.5em 0;
	}

	#dropzone .dz-preview {
		width: 160px;
		display: inline-block;
	}
	#dropzone .dz-preview .dz-image > div {
		width: inherit;
		height: inherit;
		border-radius: 50%;
		background-size: contain;
	}
	#dropzone .dz-preview .dz-image > img {
		width: 100%;
	}

	#dropzone .dz-preview .dz-details {
		color: rgb(0, 0, 0);
		transition: opacity 0.2s linear;
		text-align: center;
	}
	#dropzone .dz-success-mark,
	.dz-error-mark,
	.dz-remove {
		display: none;
	}

	.dropzone.dz-started .dz-message {
		display: block;
	}
</style>
